export default __webpack_public_path__ + "static/media/settings.6c9ed5ca.svg";